/* eslint-disable max-len */
import React from "react"

const MultiCommentsFilled = (props) => {
  return (
    <svg {...props} width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M7.5 13.7497V18.333C7.5 18.5761 7.59658 18.8093 7.76849 18.9812C7.94039 19.1531 8.17355 19.2497 8.41667 19.2497H19.4625L24 22.9163V8.24967C24 8.00656 23.9034 7.7734 23.7315 7.60149C23.5596 7.42959 23.3264 7.33301 23.0833 7.33301H18.5"
        fill="#21295C"
      />
      <path
        d="M1.25 17.4163C1.25 17.7053 1.41601 17.9686 1.67677 18.0931C1.93752 18.2177 2.24663 18.1813 2.47139 17.9997L6.80265 14.4997H17.5833C18.0254 14.4997 18.4493 14.3241 18.7618 14.0115C19.0744 13.699 19.25 13.275 19.25 12.833V2.74967C19.25 2.30765 19.0744 1.88373 18.7618 1.57116C18.4493 1.2586 18.0254 1.08301 17.5833 1.08301H2.91667C2.47464 1.08301 2.05072 1.2586 1.73816 1.57116C1.4256 1.88372 1.25 2.30765 1.25 2.74967V17.4163Z"
        fill="#21295C"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MultiCommentsFilled
